import {
  AnyAction,
  combineReducers
} from 'redux';

import { isGetCheckVersionSuccess } from './actions';
import { Checks } from './state';

export const INITIAL_STATE: Checks = {
  allCodes: [ ],
  byCode: { },
  count: null,
  latestCodeById: { }
};

// Reducers

function allCodes(state = INITIAL_STATE.allCodes, action: AnyAction): Checks['allCodes'] {
  if (isGetCheckVersionSuccess(action)) {
    const check = action.payload.data;
    const code = check.code;
    const isAlreadyExisting = state.includes(code);
    return isAlreadyExisting ? state : [ ...state, code ];
  }

  return state;
}
function byCode(state = INITIAL_STATE.byCode, action: AnyAction): Checks['byCode'] {
  if (isGetCheckVersionSuccess(action)) {
    const check = action.payload.data;
    const code = check.code;
    return { ...state, [ code ]: check };
  }

  return state;
}
function latestCodeById(
  state = INITIAL_STATE.latestCodeById,
  action: AnyAction
): Checks['latestCodeById'] {
  if (isGetCheckVersionSuccess(action)) {
    const isLatestVersion = action.meta.previousAction.check.version === 'latest';
    if (isLatestVersion) {
      const check = action.payload.data;
      const id = check.id.entityId;
      const code = check.code;
      return { ...state, [ id ]: code };
    }
  }

  return state;
}
function count(state = INITIAL_STATE.count /*, action: AnyAction */): Checks['count'] {
  // no action to fetch total check count currently exists
  return state;
}

export const checks = combineReducers({
  allCodes,
  byCode,
  count,
  latestCodeById
});
